/* =====================================================================
   Sabeel Copperworks — storefront behaviour
   No framework, no build step. Three concerns, in order:
     1. motion    — condensing header, scroll progress, parallax, reveals
     2. cart      — drawer, AJAX add/change, server-rendered re-paint
     3. product   — variant selection, gallery
   ===================================================================== */
(function () {
  'use strict';

  var R = window.SabeelRoutes || {};
  var S = window.SabeelStrings || {};
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------
     0. LOADER
     The CSS already dismisses the curtain on a timer. This only ever
     makes it leave sooner, and skips it entirely after the first page
     of a session — a loader you sit through on every click stops being
     charming by the third page.
     --------------------------------------------------------------- */

  var curtain = document.getElementById('sbl-load');
  if (curtain) {
    var seen = false;
    try { seen = sessionStorage.getItem('sbl-seen') === '1'; } catch (e) { seen = false; }

    if (seen) {
      curtain.classList.add('done');
    } else {
      try { sessionStorage.setItem('sbl-seen', '1'); } catch (e) {}
      var dismiss = function () { curtain.classList.add('done'); };
      if (document.readyState === 'complete') {
        setTimeout(dismiss, 900);
      } else {
        addEventListener('load', function () { setTimeout(dismiss, 500); });
      }
      /* belt and braces: never leave the curtain up, whatever happens above */
      setTimeout(dismiss, 2600);
    }
  }

  /* ---------------------------------------------------------------
     1. MOTION
     --------------------------------------------------------------- */

  var hdr  = $('#hdr');
  var prog = $('#prog');
  var PX   = [];   // parallax targets, recollected whenever the DOM changes

  function collectPx() {
    PX = [];
    var hi = $('.hero-img');
    if (hi) PX.push({ el: hi, k: 0.22, kind: 'y' });
    var hin = $('.hero-in');
    if (hin) PX.push({ el: hin, k: -0.14, kind: 'hero-copy' });
    $$('.feat-im img').forEach(function (el) { PX.push({ el: el, k: 0.06, kind: 'frame' }); });
    var latt = $('.qb .latt');
    if (latt) PX.push({ el: latt, k: 0.09, kind: 'frame' });
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }

  function frame() {
    ticking = false;
    var y = scrollY;
    if (hdr) hdr.classList.toggle('stuck', y > 24);
    if (prog) {
      var max = document.documentElement.scrollHeight - innerHeight;
      prog.style.width = (max > 0 ? Math.min(y / max, 1) * 100 : 0) + '%';
    }
    if (REDUCED) return;
    var vh = innerHeight;
    for (var i = 0; i < PX.length; i++) {
      var p = PX[i];
      if (p.kind === 'y') {
        p.el.style.transform = 'translate3d(0,' + (y * p.k) + 'px,0)';
      } else if (p.kind === 'hero-copy') {
        var t = Math.min(y / (vh * 0.9), 1);
        p.el.style.transform = 'translate3d(0,' + (y * 0.16) + 'px,0)';
        p.el.style.opacity = String(1 - t * 0.85);
      } else {
        var r = p.el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var mid = r.top + r.height / 2 - vh / 2;
        p.el.style.transform = 'translate3d(0,' + (-mid * p.k) + 'px,0)';
      }
    }
  }

  /* Reveal on scroll. Siblings stagger by 80ms so a grid arrives as a
     sequence rather than a slab — capped at 6 so long grids stay brisk. */
  var io;
  function observe() {
    if (io) io.disconnect();
    if (!('IntersectionObserver' in window) || REDUCED) {
      $$('.rv,.rv-l,.rv-r').forEach(function (el) { el.classList.add('in'); });
      collectPx();
      return;
    }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sibs = Array.prototype.slice.call(e.target.parentNode.children).filter(function (c) {
          return c.classList.contains('rv') || c.classList.contains('rv-l') || c.classList.contains('rv-r');
        });
        var d = Math.min(Math.max(sibs.indexOf(e.target), 0), 6) * 80;
        setTimeout(function () { e.target.classList.add('in'); }, d);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0.06 });
    $$('.rv,.rv-l,.rv-r').forEach(function (el) { io.observe(el); });
    collectPx();
  }

  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });

  /* Rotating announcement. */
  var annS = $('#ann span');
  if (annS && !REDUCED) {
    var lines = [];
    try { lines = JSON.parse(annS.dataset.lines || '[]'); } catch (e) { lines = []; }
    if (lines.length > 1) {
      var ai = 0;
      setInterval(function () {
        annS.style.opacity = 0;
        setTimeout(function () {
          ai = (ai + 1) % lines.length;
          annS.innerHTML = lines[ai];
          annS.style.opacity = 1;
        }, 480);
      }, 5200);
    }
  }

  /* ---------------------------------------------------------------
     2. CART
     --------------------------------------------------------------- */

  var cartEl  = $('#cart');
  var scrim   = $('#scrim');
  var mnav    = $('#mnav');

  function openCart()  { if (cartEl) { cartEl.classList.add('on'); scrim.classList.add('on'); } }
  function closeCart() { if (cartEl) { cartEl.classList.remove('on'); scrim.classList.remove('on'); } }
  function openNav()   { if (mnav) { mnav.classList.add('on'); scrim.classList.add('on'); } }
  function closeNav()  { if (mnav) { mnav.classList.remove('on'); scrim.classList.remove('on'); } }

  var toastT;
  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* Repaint the drawer from a server-rendered section, so prices, currency
     and the free-shipping threshold stay in Liquid. */
  function paintCart(sections) {
    var html = sections && sections['cart-drawer'];
    if (!html) return refetchCart();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var items = doc.querySelector('#cartItems');
    var foot  = doc.querySelector('#cartFoot');
    if (items) $('#cartItems').innerHTML = items.innerHTML;
    if (foot)  $('#cartFoot').innerHTML  = foot.innerHTML;
    bindCartRows();
  }

  function refetchCart() {
    return fetch(R.cart + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) { paintCart({ 'cart-drawer': html }); });
  }

  function setCount(n) {
    var el = $('#cartC');
    if (!el) return;
    el.hidden = n === 0;
    el.textContent = n;
  }

  function bindCartRows() {
    $$('#cartItems .qty button').forEach(function (b) {
      b.onclick = function () {
        changeLine(b.dataset.line, b.dataset.qty);
      };
    });
  }

  function changeLine(line, quantity) {
    return fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: ['cart-drawer'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setCount(data.item_count);
        paintCart(data.sections);
        if (document.body.classList.contains('template-cart')) location.reload();
      })
      .catch(function () { toast(S.error || 'Something went wrong'); });
  }

  function addToCart(form) {
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.setAttribute('disabled', '');
    return fetch(R.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || S.error); return; }
        paintCart(res.data.sections);
        return fetch(R.cart + '.js')
          .then(function (r) { return r.json(); })
          .then(function (c) {
            setCount(c.item_count);
            openCart();
            toast(S.added || 'Added to cart');
          });
      })
      .catch(function () { toast(S.error || 'Something went wrong'); })
      .then(function () { if (btn) btn.removeAttribute('disabled'); });
  }

  /* ---------------------------------------------------------------
     3. PRODUCT
     --------------------------------------------------------------- */

  function initProduct() {
    var form = $('[data-product-form]');
    if (!form) return;

    var data = $('#variant-data');
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[name=id]');
    var priceEl = $('[data-price]');
    var submit  = form.querySelector('[type=submit]');
    var stockEl = $('[data-stock]');

    function selected() {
      return $$('[data-opt-group]').map(function (g) {
        var on = g.querySelector('button.on');
        return on ? on.dataset.value : null;
      });
    }

    function match() {
      var chosen = selected();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var hit = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] !== null && v.options[j] !== chosen[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    function apply() {
      var v = match();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (submit) {
        submit.textContent = v.available
          ? (submit.dataset.add + ' — ' + v.price_plain)
          : (S.soldOut || 'Sold out');
        submit.toggleAttribute('disabled', !v.available);
      }
      if (stockEl) {
        stockEl.innerHTML = v.stock_html;
      }
      if (history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    $$('[data-opt-group] button').forEach(function (b) {
      b.onclick = function () {
        Array.prototype.forEach.call(b.parentNode.children, function (s) { s.classList.remove('on'); });
        b.classList.add('on');
        apply();
      };
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(form);
    });

    /* Gallery */
    $$('.gal-t button').forEach(function (b) {
      b.onclick = function () {
        var main = $('#galM');
        if (main) {
          main.src = b.dataset.full;
          main.srcset = '';
          main.alt = b.dataset.alt || main.alt;
        }
        Array.prototype.forEach.call(b.parentNode.children, function (s) { s.classList.remove('on'); });
        b.classList.add('on');
      };
    });
  }

  /* ---------------------------------------------------------------
     BOOT
     --------------------------------------------------------------- */

  var cartBtn = $('#cartBtn');
  if (cartBtn) cartBtn.onclick = function (e) { e.preventDefault(); openCart(); };
  var cartX = $('#cartX');
  if (cartX) cartX.onclick = closeCart;
  var burger = $('#burger');
  if (burger) burger.onclick = openNav;
  var mnavX = $('#mnavX');
  if (mnavX) mnavX.onclick = closeNav;
  if (scrim) scrim.onclick = function () { closeCart(); closeNav(); };
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeNav(); }
  });

  /* Any add-to-cart form outside the PDP (quick add, related products). */
  $$('form[action*="/cart/add"]').forEach(function (f) {
    if (f.hasAttribute('data-product-form')) return;
    f.addEventListener('submit', function (e) { e.preventDefault(); addToCart(f); });
  });

  bindCartRows();
  initProduct();
  observe();
  onScroll();
})();
